import React from "react";
import { ReactComponent as TickIcon } from "assets/icons/circle_tick_fill.svg";
import { ReactComponent as ClockIcon } from "assets/icons/circle_clock.svg";
import { ReactComponent as WarningIcon } from "assets/icons/circle_warning_fill.svg";
import { ReactComponent as DraftIcon } from "assets/icons/draftIcon.svg";
import { ORDER_STATUS } from "utils/Constants";
import { StatusProps } from "./Status.props";
import "./style.scss";

const Status = React.memo<StatusProps>(({ statusType, title }) => {
    const statusByType: {
        [key: string]: { className: string; icon: JSX.Element };
    } = {
        [ORDER_STATUS.changed]: {
            className: "changed-status",
            icon: <WarningIcon />,
        },
        [ORDER_STATUS.vendor_accepted]: {
            className: "accepted-status",
            icon: <TickIcon data-testid="tick-icon" />,
        },
        [ORDER_STATUS.kitchen_accepted]: {
            className: "accepted-status",
            icon: <TickIcon />,
        },
        [ORDER_STATUS.pending]: {
            className: "pending-status",
            icon: <ClockIcon />,
        },
        [ORDER_STATUS.direct_confirm]: {
            className: "accepted-status",
            icon: <TickIcon />,
        },
        [ORDER_STATUS.is_draft]: {
            className: "draft-status",
            icon: <DraftIcon />,
        },
    };

    return (
        <div className="status-wrapper d-flex justify-content-between align-items-center flex-row">
            <span className={statusByType[statusType]?.className}>{title}</span>
            {statusByType[statusType]?.icon}
        </div>
    );
});

export default Status;
